import React, { useCallback, useReducer } from 'react';
import { createFirmwareInitialState, CreateFirmwareContext, TTypeOfModalWindow } from './createFirmwareContext';
import { createFirmwareReducer } from './createFirmwareReducer';
import { CreateFirmwareActionTypes } from './createFirmwareActions';
import { IFileData, ICreateUpdateFirmware, TFirmwareType } from 'types';

const CreateFirmwareState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createFirmwareReducer, createFirmwareInitialState);

	const setTypeSelectedFirmware = useCallback((value: TFirmwareType) => {
		dispatch({
			type: CreateFirmwareActionTypes.SET_TYPE_SELECTED_FIRMWARE,
			payload: {
				typeSelectedFirmware: value,
			},
		});
	}, []);

	const changeNameOfFirmware = useCallback((value: string) => {
		dispatch({
			type: CreateFirmwareActionTypes.CHANGE_NAME_OF_FIRMWARE,
			payload: {
				nameOfFirmware: value,
			},
		});
	}, []);

	const changeVersionOfFirmware = useCallback((value: string) => {
		dispatch({
			type: CreateFirmwareActionTypes.CHANGE_VERSION_OF_FIRMWARE,
			payload: {
				versionOfFirmware: value,
			},
		});
	}, []);

	const changeDescription = useCallback((value: string) => {
		dispatch({
			type: CreateFirmwareActionTypes.CHANGE_DESCRIPTION,
			payload: {
				description: value,
			},
		});
	}, []);

	const changeFileData = useCallback((value: IFileData) => {
		dispatch({
			type: CreateFirmwareActionTypes.CHANGE_FILE_DATA,
			payload: {
				fileData: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateUpdateFirmware | null) => {
		dispatch({
			type: CreateFirmwareActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfModalWindow) => {
		dispatch({
			type: CreateFirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateFirmwareActionTypes.RESET_FIELDS }), []);

	return (
		<CreateFirmwareContext.Provider
			value={{
				setTypeSelectedFirmware,
				changeNameOfFirmware,
				changeVersionOfFirmware,
				changeDescription,
				changeFileData,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				typeSelectedFirmware: state.typeSelectedFirmware,
				nameOfFirmware: state.nameOfFirmware,
				versionOfFirmware: state.versionOfFirmware,
				description: state.description,
				fileData: state.fileData,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateFirmwareContext.Provider>
	);
};

export default CreateFirmwareState;
